import { useParams } from 'next/navigation';
import classNames from 'classnames';
import { LineItem } from 'shared/types/cart';
import DiscountedPrice from 'components/gruenland/atoms/prices/DiscountedPrice';
import Price from 'components/gruenland/atoms/prices/Price';
import StrikePrice from 'components/gruenland/atoms/prices/StrikePrice';
import Typography from 'components/gruenland/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import { TYPOGRAPHY_CART_PRICE } from 'lib/typography';

const PriceLine: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="flex items-center gap-[5px]">{children}</div>
);

const CartItemPrice: React.FC<{ item: LineItem }> = ({ item }) => {
  const { locale } = useParams();
  const { formatMessage } = useFormat({ name: 'gruenland' });

  if (item.isGift) {
    return (
      <PriceLine>
        <Typography className={classNames(TYPOGRAPHY_CART_PRICE, 'text-accent-red')}>
          {formatMessage({ id: 'cart.gift', defaultMessage: 'Omaggio' })}
        </Typography>
        <StrikePrice locale={locale} price={item.price} />
      </PriceLine>
    );
  }

  // Uno o più elementi negli sconti per quantity (Sconti a carrello)
  if (item.discountedPricePerCount && item.discountedPricePerCount.length > 0) {
    return item.discountedPricePerCount.map((x, i) => (
      <PriceLine key={i}>
        {x.count !== item.count && <>{x.count}x</>}
        <DiscountedPrice key={i} locale={locale} price={x.discountedPrice} />
        <StrikePrice locale={locale} price={item.price} />
      </PriceLine>
    ));
  }

  // Solo Sconto a Catalogo
  if (item.discountedPrice) {
    return (
      <PriceLine>
        <DiscountedPrice locale={locale} price={item.discountedPrice} />
        <StrikePrice locale={locale} price={item.price} />
      </PriceLine>
    );
  }

  // Prezzo pieno
  return <Price locale={locale} price={item.price} />;
};

export default CartItemPrice;
